// extracted by mini-css-extract-plugin
module.exports = {"moduleContent":"modulecontent_moduleContent__V3ctQ"};